import '.bu{flex-shrink:0;}.ssr-plugin'
import '.bw{padding:1rem;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.br{height:100%;}.ssr-plugin'
import '.b5{border:none;}.ssr-plugin'
import '.b6{background-color:transparent;}.ssr-plugin'
import '.en{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.bj{position:sticky;}.ssr-plugin'
import '.eo{top:4rem;}.ssr-plugin'
import '.ep{z-index:7;}.ssr-plugin'
import '.as{background-color:var(--shades-white);}.ssr-plugin'
import '.eq{padding-bottom:1rem;}.ssr-plugin'
import '.s{margin-bottom:1rem;}.ssr-plugin'
import '.er{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a8{position:fixed;}.ssr-plugin'
import '.bk{top:0px;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.es{bottom:0px;}.ssr-plugin'
import '.et{z-index:9999;}.ssr-plugin'
import '.eu{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d7{justify-content:flex-end;}.ssr-plugin'
import '.cl{flex:1;}.ssr-plugin'
import '.ax{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bu bw t br b5 b6 en"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ae"
    >
      <div className="bj eo ep as eq s er a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a8 bk bp bq es et as eu a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bw a d7 er"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="cl ax">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
